import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'CardTitleMisPartidas',
  props: {
    message: {},
    textsize: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "jugador-card" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "title" }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: _normalizeClass([props.textsize, "ringbearer"])
          }, _toDisplayString(props.message), 3)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})